import { ICopyable } from '../../common/icopyable';

export class Results<T extends ICopyable<T>> {
    value: T[];
    totalCount: number;
    resultCount: number;

    public static getCopyFrom<T extends ICopyable<T>>(type: new () => T, other: any) {
        let instance = new Results<T>();
        if (other.value) {
            instance.value = (<[]>other.value).map((x) => {
                let instance = new type();
                instance.copyFrom(x);
                return instance;
            });
        }

        instance.totalCount = other.totalCount;
        instance.resultCount = other.resultCount;
        return instance;
    }

    public static createInstance<T>(c: new () => T): T {
        return new c();
    }
}
